var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecruitment2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.083 1.50122C16.3667 1.50122 20.6668 5.80057 20.667 11.0842C20.667 13.4126 19.8319 15.5492 18.4453 17.2122L18.1523 17.5627L22.3779 21.7883C22.5406 21.951 22.5405 22.2144 22.3779 22.3772V22.3782C22.2966 22.4594 22.1904 22.4993 22.083 22.4993C21.9757 22.4992 21.8704 22.4586 21.7891 22.3772L17.8867 18.4758L17.5635 18.1526L17.2129 18.4456C15.5497 19.8329 13.4122 20.6682 11.083 20.6682C5.79935 20.668 1.5 16.368 1.5 11.0842C1.50017 5.80062 5.79945 1.50139 11.083 1.50122Z",
    stroke: "#636980"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83203 8.66667C8.83203 10.1394 10.0259 11.3333 11.4987 11.3333C12.9715 11.3333 14.1654 10.1394 14.1654 8.66667C14.1654 7.19391 12.9715 6 11.4987 6C10.0259 6 8.83203 7.19391 8.83203 8.66667Z",
    stroke: "#636980",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 14.4824C11.2333 15.8158 14.3889 15.038 15.5 14.4824C15.5 13.149 13.8333 11.8157 11.5 11.8157C8.5 11.8157 7.5 13.4823 7.5 14.4824Z",
    stroke: "#636980"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecruitment2);
export default __webpack_public_path__ + "static/media/Recruitment 2.8ef39edf752236a8aded04a1b019221c.svg";
export { ForwardRef as ReactComponent };